import { ApiRequest } from '@zeal/zeal-lib';

import { ENDPOINTS } from '../endpoints';

export async function apiForgotPassword(payload: { email: string }) {
	return new ApiRequest(ENDPOINTS.ResetUserPassword.forgotPassword)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.POST(JSON.stringify(payload));
}
